import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from "vue";
import { useI18n } from "vue-i18n-composable";

import ConditionalContext from "@/components/shared/ConditionalContext.vue";
import SimplePrice from "@/components/Loan/SimplePrice.vue";

import { capitalize, currency } from "@/helpers/filters";

import type {
  Loanable,
  Persisted,
  PricingParameter,
  Pricing,
  PricingParameterComponent,
} from "@/types/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoanableEditPricingParameters',
  props: {
    pricing: null,
    value: null,
    customPricingDisabled: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update", payload: Loanable["parameters"]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pricing: Persisted<Pricing>;
  value: Loanable["parameters"];
  customPricingDisabled: boolean;
};

const { t } = useI18n();





const customPricingParameterKeys: Array<keyof PricingParameter<PricingParameterComponent>> = [
  "distance",
  "hourly",
];

const loanablePricing = computed<PricingParameter<number | null>>(() => {
  const index = props.pricing.community_id ?? 0;
  if (props.value && props.value[index]) {
    return props.value[index];
  }

  return {
    distance: null,
    hourly: null,
    minimum: null,
  };
});

const displayedKeys = computed(() => {
  return (["distance", "hourly", "minimum"] as Array<keyof PricingParameter>).filter((key) => {
    const { minimum, maximum } = props.pricing.parameters[key];
    return minimum !== maximum && maximum !== 0;
  });
});

function $ct(key: string) {
  return t(`components.loanable.loanable_edit_pricing_parameters.${key}`);
}

function handleSlider(key: keyof PricingParameter, value: string) {
  const newLoanablePricing = {
    ...loanablePricing.value,
  };
  newLoanablePricing[key] = Number.parseFloat(value);
  emit("update", newLoanablePricing);
}

function setLoanableParameters(key: keyof PricingParameter, value: number | null) {
  const newLoanablePricing = {
    ...loanablePricing.value,
  };
  newLoanablePricing[key] = value;
  emit("update", newLoanablePricing);
}

function simplePriceLabel(key: keyof PricingParameter): string {
  if (loanablePricing.value[key] === null) {
    return `${capitalize($ct(`parametrized_price.short_${key}`))} (${$ct(
      `parametrized_price.default`
    )})`;
  }
  return capitalize($ct(`parametrized_price.short_${key}`));
}

watch(
  () => props.customPricingDisabled,
  (disabled) => {
    if (!disabled) {
      return;
    }

    customPricingParameterKeys.forEach((key) => {
      setLoanableParameters(key, null);
    });
  }
);

function isCustomPricingParameterDisabled(
  key: keyof PricingParameter<PricingParameterComponent>
): boolean {
  return props.customPricingDisabled && customPricingParameterKeys.includes(key);
}

return { __sfc: true,t, props, emit, customPricingParameterKeys, loanablePricing, displayedKeys, $ct, handleSlider, setLoanableParameters, simplePriceLabel, isCustomPricingParameterDisabled, ConditionalContext, SimplePrice, capitalize, currency }
}

})